import { render } from "./TemplateNavigation.vue?vue&type=template&id=a42d8832&ts=true"
import script from "./TemplateNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateNavigation.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/components/TemplateNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a42d8832"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a42d8832', __exports__)) {
    api.reload('a42d8832', __exports__)
  }
  
  module.hot.accept("./TemplateNavigation.vue?vue&type=template&id=a42d8832&ts=true", () => {
    api.rerender('a42d8832', render)
  })

}


export default __exports__